module.exports = __webpack_public_path__ + "img/cover.5033f5af.png";